"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../../styles/components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Todo: Styling is repeating for each component.
//  Can we live with this or should global styles
//  be created? How does style-components handle
//  relationships between components?

/* eslint react/prefer-stateless-function:0 */
var Index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Index, _React$PureComponent);

  function Index() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Index.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        classifiers = _this$props.classifiers,
        title = _this$props.title;
    return /*#__PURE__*/_react["default"].createElement(_components["default"].Fields, null, classifiers.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    }).map(function (classifier) {
      return /*#__PURE__*/_react["default"].createElement(_components["default"].Field, {
        key: title + "_" + classifier.id
      }, /*#__PURE__*/_react["default"].createElement(_components["default"].FieldTitle, null, classifier.name, /*#__PURE__*/_react["default"].createElement(_components["default"].FieldBadge, null, "v", classifier.version)), /*#__PURE__*/_react["default"].createElement(_components["default"].FieldValue, null, classifier.label));
    }));
  };

  return Index;
}(_react["default"].PureComponent);

var _default = Index;
exports["default"] = _default;